<script lang="ts">
    import type {ChatData, UserData} from "../Types";
    import {getRouteById} from "../Nav";
    import {DateTime} from "luxon";
    import AuthImage from "./AuthImage.svelte";

    export let user: UserData;
    export let chat: ChatData;
    export let chat_id: string;
    let el: any


    import {afterUpdate} from 'svelte';
    import AddContactAsUserButton from "./AddContactAsUserButton.svelte";
    import ContactButton from "./ContactButton.svelte";

    afterUpdate(() => {
        if (chat_id == chat.id) {
            el?.scrollIntoView({block: 'center'})
        }
    });
</script>
<tr class:table-active={chat_id==chat.id} bind:this={el}>
    <td>
        <a href="#{getRouteById('UserChats').hash(user.id, chat.id)}">{chat.id}</a>
    </td>
    <td>
        {#if chat.contact?.small_path!=null}
            <AuthImage width="50" src="/user/{user.id}/contact/{chat.contact.id}/avatar"/>
        {/if}
        {#if chat.contact?.attachments && chat.contact?.attachments?.length > 0}
            {#if chat.contact.attachments[0]?.telegram_attachment_id?.length > 0 || chat.contact.attachments[0]?.telegram_remote_attachment_id?.length > 0}
                <AuthImage
                        width="50"
                        imageClass="rounded-circle"
                        src="/user/{user.telegram_id}/contact/{chat.contact.telegram_contact_id}/attachment/{chat.contact.attachments[0]?.telegram_attachment_id ?? ''}/{chat.contact.attachments[0]?.telegram_remote_attachment_id ?? '1'}"
                />
            {/if}
        {/if}
    </td>
    <td>
        {#if chat.type === 'chatTypeSupergroup'}
            Канал
        {:else if chat.type === 'chatTypeBasicGroup'}
            Група
        {:else if chat.type === 'chatTypePrivate'}
            Чат
        {:else if chat.type === 'chatTypeSecret'}
            Секр. чат
            <!--{if chat.contact.}-->
        {:else}
            {chat.type}
        {/if}
    </td>
    <td>
        <a href="#{getRouteById('UserChats').hash(user.id, chat.id)}">{chat.title}</a>
    </td>
    <td>{#if chat.is_channel}<i class="bi bi-check"></i>{/if}</td>
    <td class="text-end">{chat.total_messages}</td>
    <td>{chat.last_message_at ? DateTime.fromISO(chat.last_message_at).toFormat("yyyy-MM-dd") : ''}</td>
    <td class="text-nowrap">
        {#if chat.contact}
            <ContactButton
                telegram_id={chat.contact.telegram_contact_id}
                phone={chat.contact.phone}
            ><i class="bi bi-chevron-right"></i><i class="bi bi-person"></i></ContactButton>
        {/if}
    </td>
    <td><AddContactAsUserButton contact={chat.contact}/></td>
</tr>
